import React, { useEffect, useState } from "react";
import { SendRequest } from "../../util/AxiosUtil";

const formatDeployedAt = (value) => {
  if (!value) return "Not deployed (running locally)";
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? value : `${parsed.toUTCString()}`;
};

const Diagnostics = () => {
  const [version, setVersion] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    SendRequest({
      method: "get",
      url: "api/Version",
    })
      .then((response) => {
        setVersion(response.data);
      })
      .catch(() => {
        setError("Could not load version information.");
      });
  }, []);

  return (
    <div className="row my-auto">
      <div className="col-12 col-md-8 offset-md-2 mt-3">
        <h1>System Diagnostics</h1>
        <p className="text-muted">
          Identifies the build currently running in this environment.
        </p>

        {error && <div className="alert alert-danger">{error}</div>}

        {!error && !version && <p>Loading...</p>}

        {version && (
          <table className="table">
            <tbody>
              <tr>
                <th scope="row">Environment</th>
                <td>{version.Environment}</td>
              </tr>
              <tr>
                <th scope="row">Commit</th>
                <td>
                  <code>{version.ShortCommit}</code>
                  <div className="text-muted small">{version.Commit}</div>
                </td>
              </tr>
              <tr>
                <th scope="row">Branch</th>
                <td>{version.Branch}</td>
              </tr>
              <tr>
                <th scope="row">Deployed at</th>
                <td>{formatDeployedAt(version.DeployedAt)}</td>
              </tr>
              <tr>
                <th scope="row">Build run</th>
                <td>{version.RunNumber || "-"}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Diagnostics;
